/* eslint-disable import/no-cycle */
import { all, call, put, select, takeLeading } from 'redux-saga/effects'

import { actions, selectors } from '../index'
import ApiSagas from '../api/sagas'
import { userPlanById } from '../../graphql/Services/User/queries'

export default class EarlierPlanningSagas {
  static *init(ctx: any) {
    const plan = yield select(selectors.earlierplanning.plan)
    if (!plan || plan?.id !== ctx?.query?.id) {
      yield put(actions.app.setIsLoading(true))
    }
  }

  static *load(action: ReturnType<typeof actions.earlierplanning.load>) {
    const plan = yield select(selectors.earlierplanning.plan)
    if (!plan || plan?.id !== action.payload.id) {
      yield put(actions.app.setIsLoading(true))
    }

    const result = yield call(
      ApiSagas.query,
      userPlanById({
        id: action.payload.id,
      })
    )

    if (result?.data) {
      yield put(actions.earlierplanning.setPlan(result?.data))
      yield put(actions.app.setIsLoading(false))
    } else {
      return { error: 404 }
    }
  }

  static *loop() {
    yield all([takeLeading(actions.earlierplanning.load as any, this.load)])
  }
}
